import { render, staticRenderFns } from "./loadrate.vue?vue&type=template&id=1e8f8a9f&scoped=true&"
import script from "./loadrate.vue?vue&type=script&lang=js&"
export * from "./loadrate.vue?vue&type=script&lang=js&"
import style0 from "./loadrate.vue?vue&type=style&index=0&id=1e8f8a9f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8f8a9f",
  null
  
)

export default component.exports